<div class="font-weight-bold text-primary font-size-normal">
    <ng-content></ng-content>
</div>
